// utils/scenarioHelpers.js
export const getMonthName = (monthNum) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[monthNum - 1] || '';
};

export const formatNumber = (value) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const parseAdjustmentKey = (key) => {
  const [year, accountId, month] = key.split('-');
  return {
    year: parseInt(year),
    accountId,
    month: parseInt(month)
  };
};

/**
 * Flatten all line items including children from organized data
 * This ensures we can look up ANY account at ANY level
 */
export const flattenAllLineItems = (organizedData) => {
  const allItems = [];
  
  // Helper to recursively extract all items
  const extractItems = (items) => {
    items.forEach(item => {
      allItems.push(item);
      // If item has children, extract them too
      if (item.children && item.children.length > 0) {
        extractItems(item.children);
      }
    });
  };
  
  // Extract from all categories
  if (organizedData.income) extractItems(organizedData.income);
  if (organizedData.cogs) extractItems(organizedData.cogs);
  if (organizedData.expenses) extractItems(organizedData.expenses);
  if (organizedData.otherIncome) extractItems(organizedData.otherIncome);
  if (organizedData.otherExpenses) extractItems(organizedData.otherExpenses);
  
  return allItems;
};

export const getAdjustmentDetails = (scenario, lineItems) => {
  const details = [];
  
  Object.entries(scenario.user_adjustments || {}).forEach(([key, value]) => {
    const { year, accountId, month } = parseAdjustmentKey(key);
    
    // Find the EXACT matching account by account_id
    const item = lineItems.find(i => String(i.account_id) === String(accountId));
    
    if (item) {
      details.push({
        key,
        account_id: accountId,
        account_name: item.account_name, // This should be the child name like "SEO/PPC"
        fully_qualified_name: item.fully_qualified_name, // Full path like "Marketing Expense:SEO/PPC"
        month,
        year,
        value
      });
    } else {
      // Account not found - show ID instead
      console.warn('Account not found for adjustment:', accountId);
      details.push({
        key,
        account_id: accountId,
        account_name: `Unknown Account (${accountId})`,
        fully_qualified_name: null,
        month,
        year,
        value
      });
    }
  });
  
  // Sort by year, then month, then account name
  details.sort((a, b) => {
    if (a.year !== b.year) return a.year - b.year;
    if (a.month !== b.month) return a.month - b.month;
    return a.account_name.localeCompare(b.account_name);
  });
  
  return details;
};

export const getTempRowsCount = (temporaryRows) => {
  return Object.values(temporaryRows || {}).reduce(
    (sum, rows) => sum + rows.length, 
    0
  );
};

export const getAdjustmentsCount = (userAdjustments) => {
  return Object.keys(userAdjustments || {}).length;
};